export const PERMISSIONSLIST = {
  Add_NEW_Salary_Grade: 1,
  Search_Salary_Grade: 2,
  All_Salary_Grade: 3,
  Accept_Reject_Salary_Grade: 4,
  AddAgent: 5,
  Agents_List: 6,
  Dashboard_Salary_Grade_Statistics: 7,
  Dashboard_JD_Statistics: 8,
  Add_Job_Description: 9,
  Add_Template: 10,
  Approve_Job_Description: 11,
  View_Projects: 12,
  Template_List: 13,
  Deals: 14,
  Send_Client_Proposal_Request: 15,
  Upload_Proposal_Request: 16,
  Approve_Proposal_Request: 17,
  Send_Bidding_Request: 18,
  Approve_Bidding_Request: 19,
  Notify_With_Allocation_Request: 20,
  Resource_Allocation: 24,
  NTP: 25,
  Add_portfolio_manager: 26,
  Add_Team_Member: 27,
  Add_Task: 28,
  View_Tasks: 29,
  View_Project_Documents: 30,
  Add_Project_Documents: 31,
  Send_NTI: 32,
  Portfolio_Permissions: 34,
  Project_Manager_Permissions: 35,
  All_Project: 36,
  Project_Logs: 37,
  JOB_DESCRIPTION_STATISTICS: 38,
  SALARY_GRADE_STATISTICS: 39,
  Approve_Task: 41,
  Remove_Task: 42,
  Resources_Utilization: 43,
  Change_Project_Status: 44,
  Delegate_Proposal: 45, 
  REMOVE_PROPOSAL_DOCUMENT: 49,
};

export const ConvertPermissions = () => {
  if (localStorage.getItem("token") && localStorage.getItem("permissions")) {
    let permissions = localStorage.getItem("permissions").split(",");
    let PERMISSIONS_ARR = [];
    permissions.map((user_permission) => {
      Object.keys(PERMISSIONSLIST).map(function (key) {
        if (key === user_permission) {
          PERMISSIONS_ARR.push(key);
        }
      });
    });
    return PERMISSIONS_ARR;
  }
};

export const isUserHasPermission = (permission) => {
  let USER_PERMISSIONS = ConvertPermissions();
  return USER_PERMISSIONS ? USER_PERMISSIONS.includes(permission) : null;
};

export const isSuperAdmin = () => {
  // if (localStorage.getItem("token") && localStorage.getItem("roles")) {
  //   let rolesArr = localStorage.getItem("roles").split(",");
  //   let isSuperAdmin = rolesArr.includes("SUPER_ADMIN");
  //   return isSuperAdmin;
  // }
  if (localStorage.getItem("isSuperAdmin") === "true") {
    return true;
  } else return false;
};
